import React from 'react';
import { BreadcrumbsItem } from 'react-breadcrumbs-dynamic';
import PropTypes from 'prop-types';

import BaseListContainer from '../baseContainers/BaseListContainer';
import CriteriaTextComponent from '../components/criteria/CriteriaTextComponent';
import RefuseTypeService from '../services/RefuseTypeService';

class RefuseTypeListContainer extends BaseListContainer {
	constructor(props) {
		super(props, new RefuseTypeService());
		this.state = {
			list: [],
			loading: true,
			size: 0,
			first: 0,
			criteria: this.getCleanSearchCriteria(),
		};
	}


	updateSearchCriteria(criteria) {
		return  {
			id: criteria.id,
			name: criteria.name,
			firstResult: criteria.firstResult,
			maxResult: criteria.maxResult,
			sortField: criteria.sortField,
			sortAsc: criteria.sortAsc,
		};
	}

	getCriteriaName() {
		return 'refuse-type-list-sc';
	}

	getContainerListName() {
		return 'refuse-type-list-container';
	}

	getCleanSearchCriteria() {
		return {
			id: null,
			name: '',
			firstResult: 0,
			maxResult: 10,
			sortField: 'lp',
			sortAsc: true,
		};
	}

	initializeFromBackend() {
    }

	renderCriteria() {
		return (
			<div className='row'>
				<CriteriaTextComponent
					id="name-sc"
					name="name"
					label="Nazwa typu odpadów"
					colClass="col-lg-4 col-sm-6"
					value={this.state.criteria.name}
					onChange={this.handleChangeSc}
					validator={this.validator}
				/>
			</div>
		);
	}

	prepareColumns() {
		return [
			{ field: 'lp', header: 'Lp.', sortable: true },
			{ field: 'name', header: 'Nazwa typu odpadów w języku polskim', sortable: true },
			{ field: 'nameEng', header: 'Nazwa typu odpadów w języku angielskim', sortable: true },
			{
				key: 'actions',
				header: 'Szczegóły',
				body: this.actionTemplate,
				className: 'table-column-action',
			},
		];
	}

	prepareHeaderItems() {
		return this.isUserInAnyRole('ROLE_ADMIN_SUPER_MANAGE', 'ROLE_REFUSE_TIMETABLE_MANAGE')
			? [
				{
					label: 'Nowy typ odpadów',
					href: this.props.newUrl,
					type: 'BUTTON',
					className: 'float-right',
					variant: 'yellow',
					iconName: 'mdi-plus',
					iconSide: 'left',
					iconColor: 'white',
				},
			]
			: [];
	}

	render() {
		return (
			<div className='container-fluid'>
				<BreadcrumbsItem to='/refuse-type-list'>{'Typy odpadów'}</BreadcrumbsItem>
				{this.renderView()}
			</div>
		);
	}
}

RefuseTypeListContainer.defaultProps = {
	detailUrl: '/#/refuse-type/details',
	newUrl: '/#/refuse-type/create',
};

RefuseTypeListContainer.propTypes = {
	detailUrl: PropTypes.string,
	newUrl: PropTypes.string,
};

export default RefuseTypeListContainer;
